import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text, Image } from 'rebass/styled-components';
import { Button } from '@getro/rombo';
import { ArrowRight } from 'lucide-react';
import IconStars from '../../../../assets/icon-stars.svg';
import { CONTACT_AGENT_BOOST_MEETING_URL } from '../../../../helpers/constants';

export const AICreditsSection = ({ availableCredits }) => (
  <Box
    sx={{
      bg: 'neutral.20',
      borderRadius: '8px',
      p: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Flex sx={{ gap: '4px', alignItems: 'center', justifyContent: 'space-between' }}>
        <Flex sx={{ gap: '4px', alignItems: 'center', flex: 1 }}>
          <Text fontSize="18px" fontWeight="semibold" color="text.dark" lineHeight="1.4">
            AI credits
          </Text>
          <Image src={IconStars} width="24px" height="24px" alt="Stars" />
        </Flex>
        <Text fontSize="18px" fontWeight="semibold" color="text.dark" lineHeight="1.4">
          {Intl.NumberFormat('en-US').format(availableCredits)} available
        </Text>
      </Flex>
      <Text fontSize="14px" color="text.main" lineHeight="1.4">
        You get 30 free credits every month to discover our AI Agents, to be used within that month.
      </Text>
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Text fontSize="14px" fontWeight="medium" color="text.dark" lineHeight="1.4">
        Contact us to add more credits and keep boosting jobs.
      </Text>
      <Button
        variant="secondary"
        onClick={() => window.open(CONTACT_AGENT_BOOST_MEETING_URL, '_blank', 'noopener,noreferrer')}
        sx={{
          alignSelf: 'flex-start',
          height: '32px',
          px: '16px',
          py: '8px',
          fontSize: '14px',
          fontWeight: 'medium',
          lineHeight: '16px',
          borderColor: 'border.default',
        }}
        icon={ArrowRight}
        iconPosition="right"
        iconGap="8px"
      >
        Let&apos;s talk
      </Button>
    </Box>
  </Box>
);

AICreditsSection.propTypes = {
  availableCredits: PropTypes.number.isRequired,
};
